import { FaqSchemaItem, toFaqList } from '../../builders/faq'

export const cloudnativeFaqItems: FaqSchemaItem[] = [
  {
    question: '既にAWS（Azure/GCP）に移行済みですが、サーバーレス化のメリットはありますか？',
    answer:
      'リソース管理やスケーリングを自動化することで運用コストと開発負荷を大幅に削減できます。また、従量課金モデルにより、トラフィックに応じた最適なコスト構造を実現できます。さらに、インフラ管理から解放されることで、ビジネスロジックの開発に集中できるようになります。',
  },
  {
    question: 'マイクロサービス化にはどれくらいの期間がかかりますか？',
    answer:
      'システム規模や要件次第ですが、PoC〜本番導入まで数カ月〜1年程度のフェーズ分割を推奨します。一度にすべてを移行するのではなく、優先度の高い機能から段階的に移行することで、リスクを最小限に抑えながら進めることができます。',
  },
  {
    question: 'データ統合基盤はどのようなツールを使いますか？',
    answer:
      'お客様の環境や要件に合わせてAWS Glue、Azure Data Factory、GCP Dataflowなどを選定し、最適構成を提案します。また、データレイク構築にはS3やADLS、分析基盤にはRedshift、BigQuery、Snowflakeなど、目的に応じた最適なツールを組み合わせて設計します。',
  },
  {
    question: 'DevOps導入を社内で推進するためのサポートはありますか？',
    answer:
      'ツール導入だけでなく、組織体制やワークフロー設計など、包括的に支援します。また、チームメンバー向けのトレーニングプログラムや、段階的な導入計画の策定もサポートしています。DevOpsの文化醸成も含めた長期的な視点でのコンサルティングを提供します。',
  },
  {
    question: '段階的に導入できるといっても、途中で追加コストがかさまないか心配です。',
    answer:
      '導入ロードマップ策定時に大枠のコスト予測を行い、PoCでの検証結果を踏まえて柔軟に調整します。また、各フェーズごとに投資対効果を測定し、次のステップに進むかどうかを判断できるようにしています。予算に合わせた段階的な導入計画を立てることで、コストを管理しながら進めることが可能です。',
  },
]

export const cloudnativeFaqList = toFaqList(
  'よくあるご質問',
  'クラウドネイティブ化に関するよくあるご質問にお答えします',
  cloudnativeFaqItems,
)
